// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__fXn4V","component":"styles_component__2jAih"};